<template>
  <section>
    <section class="grid-flex column">
      <!-- filters -->
      <div class="flex-1 w100">
        <div class="flex">
          <tabs :data="reportTabs" v-model="currentTab"></tabs>
        </div>
      </div>
    </section>
    <!-- profit -->
    <sale v-if="currentTab === 'sale'"></sale>
    <!-- lead -->
    <lead v-if="currentTab === 'lead'"></lead>
    <!-- message -->
    <message v-if="currentTab === 'message'"></message>
  </section>
</template>

<script>
import Tabs from "@/components/tabs/Tabs";

import Sale from "./Sale";
import Lead from "./Lead";
import Message from "./Message";

export default {
  name: "dash-jorney",
  components: {
    Tabs,
    Sale,
    Lead,
    Message,
  },
  props: ['slug'],
  data() {
    return {
      loading: false,
      currentTab: "sale",
      reportTabs: [
        {
          name: "sale",
          title: "Vendas",
        },
        {
          name: "lead",
          title: "Leads",
        },
        {
          name: "message",
          title: "Conversas (WhatsApp)",
        },
      ],
    };
  },
  mounted() {
    if (this.slug) {
      this.currentTab = this.slug
    }
  },
  watch: {
    slug() {
      if (this.slug) {
        this.currentTab = this.slug
      } 
    },
    currentTab() {
      if (this.slug === this.currentTab) {
        return
      }
      this.$router.push({ name: "Jorney", params: { slug: this.currentTab } });
    }
  }

};
</script>

<style lang="scss" scoped></style>
